export default __webpack_public_path__ + "dd9232d.png";